export enum UploadFileFormat {
  MonthlyAggregate = 'monthly_aggregate',
  FacebookOfflineEvent = 'facebook_offline_event',
}
